import React from "react";

import type { ContactMethod } from "./contact.types";

import styles from "./ContactMethodCard.module.css";

/** One contact route: a heading, the reachable value, and when to use it. */
const ContactMethodCard = ({ detail, href, note, title }: ContactMethod) => {
	return (
		<section className={styles.card}>
			<h2 className={styles.title}>{title}</h2>
			{href ? (
				<a className={styles.detail} href={href}>
					{detail}
				</a>
			) : (
				<p className={styles.detail}>{detail}</p>
			)}
			<p className={styles.note}>{note}</p>
		</section>
	);
};

export default ContactMethodCard;
